class SimpleMenuControler {

  //
  //  ArchiveControler Documentatie
  //
  //  - Breng simpele ajax functies binnen een pagina
  //  - Geen specifieke HTML logica, wel loading, etc.
  //  - Pagina wordt in eerste instantie gevuld via PHP
  //
  //  Depandancy: jQuery - voor $.get functie
  //
  //  1. Registeer menu met links erin (href voor ajax-link,  class="active" voor actief item)
  //  2. Geef te gebruken section_menu op en de te wijzigen section_container
  //  3. (optioneel) Gebruik callbacks (ondersteund standaard functie per event)
  //

  constructor() {
    this.version = 1.1;               // versiebeheer van script

    this.self_loading = false;        // zelf bezig
    this.self_loading_classname = 'section-loading'; // eigen loadingclass voor de body

    this.section_menu = null;         // monitor links 
    this.section_menu_links = null; 
    this.section_container = null;    // ajax vevangt innerHTML
    this.section_observer = null;     // monitor innerHTML

    this.callbacks = {
      'load' : null,
      'endload' : null,
      'change' : null,
      'ajax' : null,
      'new-content' : null
    };
  }

  // Config

  register_section_menu( _el ) {
    if( _el == null ) return;
    this.section_menu = _el;
    this.section_menu_links = this.section_menu.querySelectorAll('a');
    this.section_menu_links.forEach(element => {
      element.addEventListener('click', this.menulink_clicked.bind({element: element, controler: this}));
    });
  }

  register_section_container( _el ) {
    if( _el == null ) return;

    this.section_observer = new MutationObserver( this.section_changed.bind(this) );
    this.section_observer.observe( _el, { 
      childList: true,
      subtree: true // indien noodzakelijk true, default false 
    });
    this.section_container = _el;
  }

  register_self_loading_classname( _classname ) {
    this.self_loading_classname = _classname;
  }

  on( _eventname, _callback_function ) {
    if( !(typeof _callback_function == 'function') ) { console.log('callback mist functie'); return; }
    if( !this.callbacks.hasOwnProperty(_eventname )){ console.log('onbekend event voor callback'); return; }
    this.callbacks[_eventname] = _callback_function;
  }

  // Loading

  start_loading() {
    this.self_loading = true;

    if( this.self_loading_classname && !document.body.classList.contains(this.self_loading_classname) )
      document.body.classList.add(this.self_loading_classname);

    if( typeof this.callbacks['load'] === 'function' )
      this.callbacks['load'](this);
  }

  stop_loading() {
    this.self_loading = false;

    if( this.self_loading_classname && document.body.classList.contains(this.self_loading_classname) )
      document.body.classList.remove(this.self_loading_classname);

    if( typeof this.callbacks['endload'] === 'function' )
      this.callbacks['endload'](this);
  }

  // Input Events

  menulink_clicked( e ) {
    e.preventDefault();
    if( this.element.classList.contains('active')) return;
    if( this.self_loading ) { console.log('still loading ...'); return; }

    this.controler.section_menu.querySelector('.active').classList.remove('active');
    this.element.classList.add('active');

    var ajax_url = this.element.href;
    this.controler.update_archive(ajax_url);
  }

  section_changed() {
    if( typeof this.callbacks['change'] === 'function' )
      this.callbacks['change'](this);
    // Plaats voor animatie
    // Bijvoorbeeld door een class "new" weg te halen o.i.d.
  }

  // Ajax

  update_archive(ajax_url) {
    if( this.self_loading ) { console.log('still loading ...'); return; }
    if( this.section_container == null ) { console.log('empty section container'); return; }

    const self = this;
    self.start_loading();

    // querystring

    var data = {};

    // ajax-call

    try {
      jQuery.get(ajax_url, function (data) {
        try {
          // Custom Ajax afhandeling 1 (replace)
          if( typeof self.callbacks['ajax'] === 'function' ) {
            self.callbacks['ajax'](data, page, self);
            return;
          }

          if( !self.section_container.hasAttribute('id') ) {
            console.log('Section Container heeft geen uniek ID');
          }

          // Default Ajax afhandeling
          const parser = new DOMParser();
          const htmlDoc = parser.parseFromString(data, "text/html");
          const newContent = htmlDoc.getElementById( self.section_container.id );

          self.section_container.innerHTML = newContent.innerHTML;

          // Verander URL
          document.title =  htmlDoc.title;
          history.replaceState(null, htmlDoc.title, ajax_url);

          if( typeof self.callbacks['new-content'] === 'function' ) {
            self.callbacks['new-content'](htmlDoc, newContent);
          }

          // handle more button via mutationobserver
        } catch (e) {
          console.log(e);
        }
      })
        .fail(function (jqXHR, textStatus, errorThrown) {
          console.log(jqXHR);
          console.log(textStatus);
          console.log(errorThrown);
        })
        .always(function () {
          self.stop_loading();
        });
    } catch (e) {
      self.stop_loading();
    }

  }
}